import { useEffect, useState, type ReactNode } from 'react';
import { Link, useParams } from 'react-router-dom';
import InvitationView from '@/components/wedding/InvitationView';
import { fetchInvitationBySlug } from '@/lib/weddingApi';
import { inviteShareUrl } from '@/lib/share';
import type { WeddingInvitation } from '@/types/wedding';

function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="invite-page">
      <div className="invite-shell">{children}</div>
    </div>
  );
}

export default function InvitePage() {
  const { slug = '' } = useParams();
  const [invitation, setInvitation] = useState<WeddingInvitation | null>(null);
  const [state, setState] = useState<'loading' | 'ready' | 'missing' | 'error'>('loading');

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const inv = await fetchInvitationBySlug(slug);
        if (!active) return;
        if (inv) {
          setInvitation(inv);
          setState('ready');
        } else {
          setState('missing');
        }
      } catch {
        if (active) setState('error');
      }
    })();
    return () => {
      active = false;
    };
  }, [slug]);

  if (state === 'loading') {
    return (
      <Shell>
        <div className="invite-empty">
          <div className="pf-spinner" aria-hidden="true" />
          <p className="pf-muted">청첩장을 불러오는 중이에요…</p>
        </div>
      </Shell>
    );
  }

  if (state !== 'ready' || !invitation) {
    return (
      <Shell>
        <div className="invite-empty">
          <i className="ri-mail-open-line" aria-hidden="true" />
          <h1 style={{ fontSize: 24, margin: 0 }}>
            {state === 'error' ? '청첩장을 불러오지 못했어요' : '청첩장을 찾을 수 없어요'}
          </h1>
          <p className="pf-muted" style={{ maxWidth: '34ch' }}>
            {state === 'error'
              ? '잠시 후 다시 시도해 주세요.'
              : '링크가 만료되었거나 아직 공개되지 않은 청첩장이에요.'}
          </p>
          <Link className="pf-btn primary" to="/">
            홈으로 돌아가기
          </Link>
        </div>
      </Shell>
    );
  }

  return (
    <Shell>
      <InvitationView
        data={invitation.data}
        theme={invitation.theme}
        invitationId={invitation.id}
        shareUrl={inviteShareUrl(invitation.slug)}
        interactive
      />
    </Shell>
  );
}